import React from "react";
import { Clock } from "lucide-react";
import "./TimelineSection.css";

const TimelineSection = ({ title = "Delivery Timeline", items = [] ,end}) => {
    return (
        <div className="timeline-section">
            <h2 className="timeline-title">{title}</h2>

            <div className="timeline-grid">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className="timeline-card"
                        style={{
                            background: item.background || "#EFF6FF",
                            border: `2px solid ${item.border || "#DBEAFE"}`
                        }}
                    >
                        <h3 className="timeline-card-title">{item.name}</h3>

                        {item.description && (
                            <p className="timeline-card-text">{item.description}</p>
                        )}

                        {item.duration && (
                            <div className="timeline-duration">
                                <Clock size={18} />
                                {item.duration}
                            </div>
                        )}

                        {item.price && (
                            <div className="timeline-duration">
                                {item.price}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {end && (
                <div className="timeline-end">{end}</div>
            )}
        </div>
    );
};

export default TimelineSection;
